import type { ConsentPolicyRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'consentPolicy'
const consentPolicySiteRefProvider = getSiteFeatureBoundRefProvider(featureName)

const consentPolicyRefs: ConsentPolicyRefs = {
	currentConsentPolicy: () => consentPolicySiteRefProvider(['currentConsentPolicy']),
	openSettingModal: () => consentPolicySiteRefProvider(['openSettingModal']),
}
export { consentPolicyRefs }
